import * as R from "ramda";

export const leaveInterceptor = R.pipe(
  R.over(
    R.lensProp("options"),
    R.map(
      R.evolve({
        answer: R.trim
      })
    )
  )
);
